<template>
  <div class="publish-homework-main" v-loading="isLoading">
    <el-form :model="publishHomeworkForm" :rules="publishHomeworkRules" ref="publishHomeworkRef" label-position="top">
      <el-form-item label="作业标题" prop="homeworkTitle">
        <el-input v-model="publishHomeworkForm.homeworkTitle"></el-input>
      </el-form-item>
      <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
        <!-- <el-date-picker
          style="width: 235px"
          v-model="publishHomeworkForm.schoolYear"
          type="year"
          placeholder="选择学年"
          @change="schoolYearChangeHandle"
        >
        </el-date-picker> -->
        <year-range-picker style="width: 250px;" v-model="publishHomeworkForm.schoolYear" />
      </el-form-item>
      <el-form-item label="选择学期:" label-width="100px" prop="semester">
        <el-select v-model="publishHomeworkForm.semester" placeholder="请选择学期" style="width: 235px">
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择班级" prop="homeworkTitle">
        <el-cascader class="select" v-model="classNameVal" :placeholder="classPlaceholder" :props="classProps"
          :options="classSelect" @change="changeHandle"></el-cascader>
      </el-form-item>
      <el-form-item label="作业所属科目" prop="course">
        <el-select v-model="selectedCourseName" placeholder="请选择作业所属科目">
          <el-option :label="item.course_name" :value="item.course_name" v-for="item in courseList"
            :key="item.course_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="作业完成时间" prop="homeworkTime">
        <el-date-picker v-model="publishHomeworkForm.homeworkTime" type="datetimerange" range-separator="至"
          start-placeholder="作业开始时间" end-placeholder="作业截止时间" value-format="yyyy-MM-dd HH:mm">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="作业内容" prop="homeworkContent">
        <el-input type="textarea" v-model="publishHomeworkForm.homeworkContent" maxlength="200" show-word-limit
          :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
      </el-form-item>
      <div class="submit-homework">
        <el-button class="submit-button" @click="publishHomework">确认发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedCourseName: "",
      // courseList: [],
      isLoading: false,
      publishHomeworkForm: {
        homeworkTitle: "",
        course: "",
        homeworkTime: [],
        homeworkContent: "",
        schoolYear: "",
        semester: "",
      },
      publishHomeworkRules: {
        homeworkTitle: [
          { required: true, message: "请输入作业标题", trigger: "blur" },
          { max: 30, message: "作业标题不能超过30个字", trigger: "blur" },
        ],
        course: [{ required: true, message: "请选择作业所属科目", trigger: "change" }],
        homeworkTime: [
          { required: true, message: "请选择作业完成时间", trigger: "change" },
        ],
        homeworkContent: [
          { required: true, message: "请输入作业内容", trigger: "blur" },
          { max: 200, message: "作业内容不能超过200个字", trigger: "blur" },
        ],
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
      },
      classNameVal: "",
      classId: "",
      classInfoData: [],
      semesterOptions: [],
    };
  },
  props: ["classPlaceholder", "classProps", "classSelect", "classInfoArr", "courseList"],
  watch: {
    selectedCourseName(value) {
      const item = this.courseList.find((course) => course.course_name === value);
      if (item) {
        this.publishHomeworkForm.course = item;
      }
    },
  },
  created() {
    this.getSchoolDetails();
    this.getDictType();
  },
  mounted() {
    this.classNameVal = this.className;
    this.classInfoData = this.classInfoArr;
    // console.log(this.classInfo, this.classInfoArr);
  },
  methods: {
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        let schoolInfo = res.data;
        this.publishHomeworkForm.semester = schoolInfo.semester;
        this.publishHomeworkForm.schoolYear = schoolInfo.schoolYear;
      });
    },
    // 获取学期类型选择列表数据
    getDictType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    schoolYearChangeHandle(e) {
      // console.log(e);
      this.publishHomeworkForm.schoolYear = e ? "" + e.getFullYear() : "";
    },
    // 选择班级
    changeHandle(e) {
      // console.log(e);
      this.classInfoData = e;
      this.$emit("getCourseList", e);
    },
    publishHomework() {
      // console.log(
      //   "this.publishHomeworkForm.course.course_name==>",
      //   this.publishHomeworkForm
      // );
      // console.log("课程ID==>", this.publishHomeworkForm);
      this.$refs["publishHomeworkRef"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          this.post(this.$url.insertHomework, {
            schoolId: this.user.schoolId,
            schoolName: this.school.schoolName,
            gradeId: this.classInfoData[0].gradeId,
            gradeCode: this.classInfoData[0].gradeCode,
            gradeName: this.classInfoData[0].gradeName,
            className: this.classInfoData[1].className,
            classCode: this.classInfoData[1].classCode,
            classId: this.classInfoData[1].classId,
            courseId: this.publishHomeworkForm.course.course_id,
            courseName: this.publishHomeworkForm.course.course_name,
            teacherId: this.user.id,
            teacherName: this.user.teacherName,
            teacherNumber: this.user.teacherNumber,
            title: this.publishHomeworkForm.homeworkTitle,
            content: this.publishHomeworkForm.homeworkContent,
            publicTime: this.publishHomeworkForm.homeworkTime[0],
            endTime: this.publishHomeworkForm.homeworkTime[1],
            createBy: this.user.id,
            schoolYear: this.publishHomeworkForm.schoolYear,
            semester: this.publishHomeworkForm.semester,
          })
            .then((res) => {
              this.isLoading = false;
              if (res.code != 200) {
                return this.$message.error(res.msg);
              }
              this.$message.success("发布成功");
              this.clearPublishHomeworkForm();
              this.$emit("publishHomework");
            })
            .catch((err) => {
              this.isLoading = false;
              this.$message.error(res.msg);
            });
        } else {
          return false;
        }
      });
    },
    clearPublishHomeworkForm() {
      this.selectedCourseName = '';
      this.classNameVal = '';
      this.publishHomeworkForm = {
        homeworkTitle: "",
        course: "",
        homeworkTime: [],
        homeworkContent: "",
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "./publishHomeworkMain.scss";
</style>
